package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px


@Composable
fun FormRow(
    label: String,
    breakpoint: Breakpoint,
    content: @Composable () -> Unit
) {

    if (breakpoint <= Breakpoint.SM) {
        // MOBILE → colonne
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(6.px)
        ) {

            SpanText(
                label,
                modifier = Modifier
                    .fontWeight(FontWeight.Bold)
            )
            content()
        }
    } else {
        // DESKTOP → ligne
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.px)
        ) {
            SpanText(
                label,
                modifier = Modifier
                    .width(160.px) // largeur fixe pour alignement
                    .fontWeight(FontWeight.Bold)
            )

            Box(
                modifier = Modifier.flexGrow(1)
            ) {
                content()
            }
        }
    }
}
